import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = {
  key: 0,
  class: "card-footer d-grid gap-2 d-md-flex justify-content-md-between mt-4"
}

import { ref, computed, watch } from "vue";
import { Retiree } from "@/guiide/ts/retiree";
import { useStore } from "vuex";
import { app } from "@/guiide/ts/app";
import { formatter } from "@/db/ts/formatter";
import { FinishInfoResponse } from "@/guiide/ts/response/finishInfoResponse";
import HelpText from "@/guiide/ts/helpText";
import SubSection from "@/guiide/components/common/SubSection.vue";
import PlanTable from "../common/PlanTable.vue";
import Register from "./Register.vue";
import Help from "../common/Help.vue";

const showLaterYearsText = "Show later years";
const hideLaterYearsText = "Hide later years";

export default /*@__PURE__*/_defineComponent({
  __name: 'Plan',
  props: {
    retiree: {
        type: Object as () => Retiree | null,
        default: () => null,
    },
    finishInfo: {
        type: Object as () => FinishInfoResponse,
        default: () => new FinishInfoResponse(false, 0, []),
    }
},
  setup(__props) {

const props = __props;

const store = useStore();
const planTable = ref(null);
const register = ref(null);
const toggleLaterYearsText = ref(showLaterYearsText);
const taxSavingAmount = ref("");
const displayTaxSavingInfo = ref(false);

watch(
    () => props.finishInfo,
    (newFinishInfo: FinishInfoResponse) => {
        if (newFinishInfo == null) {
            return;
        }

        displayTaxSavingInfo.value = false;
        taxSavingAmount.value = "";

        if (newFinishInfo.hasTaxLiability && newFinishInfo.planTaxSaving >= 100) {
            displayTaxSavingInfo.value = true;
            taxSavingAmount.value = formatter.formatCurrency(newFinishInfo.planTaxSaving);
        }
    },
    { immediate: true }
)

const canViewPlanLaterYears = computed<boolean>(() => {
    if (store.state.configuration.finishCanViewPlanWithoutSignup) {
        return true;
    }

    return store.state.retiree?.isRegistered ?? false;
});

const canDownloadReport = computed<boolean>(() => {
    return store.state.configuration.finishCanDownloadReport;
});

function onToggleDisplayLaterYears() {
    if (!canShowLaterYearsOrDownloadReport()) {
        register.value.alert();
        return;
    }

    planTable.value.toggleFullPlanDisplay();
    toggleLaterYearsText.value = toggleLaterYearsText.value == showLaterYearsText ? hideLaterYearsText : showLaterYearsText;
}

async function onDownloadReport() {
    if (!canShowLaterYearsOrDownloadReport()) {
        register.value.alert();
        return;
    }

    app.downloadReport();
}

function canShowLaterYearsOrDownloadReport(): boolean {
    const canViewPlanWithoutRegistration = store.state.configuration.finishCanViewPlanWithoutSignup;

    if (canViewPlanWithoutRegistration) {
        return true;
    }

    const isRegistered = store.state.retiree?.isRegistered ?? false;
    return isRegistered;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SubSection, {
        title: "Here is your plan to get what you want",
        showHelp: false
      }, {
        footer: _withCtx(() => [
          (canViewPlanLaterYears.value || canDownloadReport.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (canViewPlanLaterYears.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn btn-outline-dark me-2 my-1",
                      onClick: onToggleDisplayLaterYears
                    }, [
                      _cache[3] || (_cache[3] = _createElementVNode("i", { class: "bi bi-calendar me-2" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(toggleLaterYearsText.value), 1)
                    ]))
                  : _createCommentVNode("", true),
                (canDownloadReport.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "btn btn-dark my-1",
                      onClick: onDownloadReport
                    }, _cache[4] || (_cache[4] = [
                      _createElementVNode("i", { class: "bi bi-download me-2" }, null, -1),
                      _createTextVNode(" Download your report")
                    ])))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        default: _withCtx(() => [
          _cache[5] || (_cache[5] = _createElementVNode("p", null, " When you retire, take the amounts shown in the table below, from your pension pots in each year. ", -1)),
          _createElementVNode("p", null, [
            _cache[2] || (_cache[2] = _createTextVNode(" This should give what you want in total when added to any savings withdrawals and everything else shown. If you want to see monthly amounts, click on monthly values. ")),
            (displayTaxSavingInfo.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _cache[0] || (_cache[0] = _createTextVNode(" Following this plan could reduce your income tax paid by around ")),
                  _createElementVNode("strong", null, _toDisplayString(taxSavingAmount.value), 1),
                  _cache[1] || (_cache[1] = _createTextVNode(", by using your tax free allowance efficiently. ")),
                  _createVNode(Help, {
                    title: "Making your plan tax efficient",
                    text: _unref(HelpText).finishTaxEfficiency()
                  }, null, 8, ["text"])
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _createVNode(PlanTable, {
            ref_key: "planTable",
            ref: planTable
          }, null, 512),
          _createVNode(Register, {
            ref_key: "register",
            ref: register,
            retiree: __props.retiree
          }, null, 8, ["retiree"])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})